import type { TrxStreamData } from 'components/admin/trx-stream/types'

export type LogFile = Pick<
  TrxStreamData,
  'instanceId' | 'serialNumber' | 'recordNumber' | 'fileType'
>

export const getNextLogFile = (
  currentPage: number,
  currentIndex: number,
  pageSize: number,
  rowCount: number,
  fileList: LogFile[],
): { page: number; index: number; file?: LogFile } | null => {
  const nextIndex = currentIndex + 1
  if ((currentPage - 1) * pageSize + nextIndex >= rowCount) return null
  if (nextIndex >= fileList.length) {
    return { page: currentPage + 1, index: 0 }
  }

  return { page: currentPage, index: nextIndex, file: fileList[nextIndex] }
}
